import { useQuery } from 'react-query';
import { lookupBuildings } from '~/api/building';

export const buildingQueryKey = (buildingId: string) => [
  'building',
  buildingId
];

export const fetchBuilding = async (buildingId: string) =>
  (await lookupBuildings({ ids: [buildingId] }))[0];

// One building from the caller's buildings, shared via the react-query cache.
export const useBuilding = (buildingId: string) =>
  useQuery(buildingQueryKey(buildingId), () => fetchBuilding(buildingId), {
    enabled: !!buildingId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  });
